module.exports = __webpack_public_path__ + "static/media/6Contact.0c19ea7b.png";